<template>
  <div id="sms_received" class="pr-3" style="width: 100%; text-align: -webkit-center"></div>
</template>
<script>
import Highcharts from "highcharts";

export default {
  extends: Highcharts,
  props: ["data"],
  mounted() {
    Highcharts.chart("sms_received", {
      chart: {
        zoomType: "x",
        height: (7 / 16) * 100 + "%",
      },
      title: {
        text: "",
      },
      subtitle: {
        text:
          document.ontouchstart === undefined
            ? "Click and drag in the plot area to zoom in"
            : "Pinch the chart to zoom in",
      },
      xAxis: {
        type: "datetime",
        width: 100 + "%",
      },
      yAxis: {
        title: {
          text: "Count",
        },
      },
      legend: {
        enabled: false,
      },
      plotOptions: {
        area: {
          fillColor: {
            linearGradient: {
              x1: 0,
              y1: 0,
              x2: 0,
              y2: 1,
            },
            stops: [
              [0, Highcharts.getOptions().colors[0]],
              [
                1,
                Highcharts.color(Highcharts.getOptions().colors[0])
                  .setOpacity(0)
                  .get("rgba"),
              ],
            ],
          },
          marker: {
            radius: 2,
          },
          lineWidth: 1,
          states: {
            hover: {
              lineWidth: 1,
            },
          },
          threshold: null,
        },
      },

      series: [
        {
          type: "area",
          name: "Count",
          data: this.data,
        },
      ],
    });
  },
};
</script>